import $ip from '@eab-pip/pi-ip';
import { KnowledgeBot } from '../core/knowledge_bot';
import { TKbiSettings } from '../types/bot_interface';

export const defaultSecuritySettings: TKbiSettings['security'] = {
  protect_data: true,
  max_input_length: 10000,
  max_session_length: 2 * 60 * 60 * 1000
};

export type TXSS = {
  sanitize: (s: string) => string;
};

export class SecurityModel {
  /**
   * sanitization rules
   */
  private xss: TXSS;

  /**
   * watch the session and timeout after limit
   */
  private __sessionTimeout: number;

  /**
   *
   */
  private __settings: TKbiSettings['security'] = defaultSecuritySettings;

  /**
   * receive the list of messages from the KnowledgeBot
   */
  constructor(private bot: KnowledgeBot) {}

  async startup() {
    await this.__loadXXS();
    return this;
  }

  async shutdown() {
    return this;
  }

  private async __loadXXS() {
    try {
      this.xss = this.xss ?? ((await $ip.require('dom-purify')) as TXSS);
    } catch {
      // silent fail because this always fails unless we are loading all of HIP
    }
  }

  configure(settings: TKbiSettings['security']) {
    this.__settings = settings;
    return this;
  }

  /**
   * we use dom-purify to sanitize the content before sending to the server
   *
   * @param s any string
   * @returns a safe string
   */
  sanitizeContent(s: string): string {
    return this.__settings.protect_data && this.xss ? this.xss.sanitize(s) : s;
  }

  /**
   * generate a timer for `session_timeout` and if it fires, then we wipe the session
   */
  keepAlive() {
    // @todo make this configurable, but the configuration on the kbi does not flow to the bot
    // 2 hours
    //
    // const sessionLimit = 15 * 1000;
    const sessionLimit = this.__settings.max_session_length;

    if (this.__sessionTimeout) {
      clearTimeout(this.__sessionTimeout);
    }

    this.__sessionTimeout = setTimeout(async () => {
      await this.bot.reset();
      await this.bot.insertMessage('Session cleared for security.', 'to-human');
    }, sessionLimit);
  }
}
